import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Image, Form, Button, Message, Modal } from 'semantic-ui-react';
import { reduxForm } from 'redux-form/immutable';
import Input from '../../components/Form/Input';
import Dropdown from '../../components/Form/Dropdown';
import {
  required,
  requiredToBeTrue,
  email,
  minLength,
  maxLength,
} from "../../utils/validations";
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  loadSignupFormOptions,
  check_signup,
  load,
  signup,
} from "../../redux/modules/auth";
import {
  getOrganizationInfoWithInviteToken,
} from '../../redux/modules/organization';
import './style.css';
import { Images } from '../../style';
import { getQueryParams } from '../../helpers/commonHelper';
import { TITLE } from '../../constants';
import { trackSignupCompletion } from "../../helpers/pixelHelper";

const minPasswordLength = minLength(3);
const minPhoneLength = minLength(8);
const maxPhoneLength = maxLength(20);
const maxLength50 = maxLength(50);

const CREATE_ACCOUNT = 'Create my account'
const FREE_TRIAL = 'Start your 30-day free trial'

const createAccountLabel = (isFree, isInvitedUser) => isFree && !isInvitedUser ? FREE_TRIAL : CREATE_ACCOUNT

class Signup extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    handleSubmit: PropTypes.func,
    user: PropTypes.object,
    signupError: PropTypes.string
  };

  static defaultProps = {
    dispatch: null,
    handleSubmit: null
  };

  state = {
    username: '',
    firstName: '',
    lastName: '',
    isTermAndPolicyChecked: '',
    isRegFormStepSecOpen: false,
    shopifyToken: '',
    store: '',
    inviteToken: '',
    inviteEmail: false,
  };

  getInviteEmail = async inviteToken => {
    const { dispatch, initialize } = this.props;

    const { invite } = await dispatch(getOrganizationInfoWithInviteToken({ inviteToken, pending: true })) || {};

    if (invite !== undefined) {
      this.setState({ inviteEmail: !!invite.email });
      initialize({ username: invite.email });
    }
  }

  componentDidMount() {
    const { dispatch, match, location } = this.props;
    const { search } = location;

    const res = getQueryParams(search);
    if(res && res.shopifyToken) {
      this.setState({ shopifyToken: res.shopifyToken, store: res.store })
    }

    if(res && res.invite_token) {
      this.setState({ inviteToken: res.invite_token });

      this.getInviteEmail(res.invite_token);
    }

    const result = TITLE.filter(title => title === match.params.title);

    if(result.length === 0){
      return dispatch(push('/'));
    }

    if (match.params.title === 'free' && typeof window.fb_pixel_shopify_FreeSignup_PageView === 'function') {
      window.fb_pixel_shopify_FreeSignup_PageView();
    }

    if (typeof fb_pixel_code_BeforeRegistration !== "undefined") {
      window.fb_pixel_code_BeforeRegistration();
    }

    dispatch(loadSignupFormOptions());
  }

  async componentDidUpdate() {
    const { user, signupInfo } = this.props;
    // we get signupInfo on signup() and the user on load()
    if (user && signupInfo) {
      await trackSignupCompletion(signupInfo.planId, !!signupInfo.isFromInvite);
      // V2-134 we don't want any other events getting triggered for the "shopify facebook pixel after the signup page.
      // After 'init' the pixel tracks events like button clicks/navigation automatically, so we have to force a page
      // refresh to get rid of the "shopify" facebook pixel on future pages.
      window.location.pathname = '/campaign';
    }
  }

  onSubmit = async (formData) => {
    const { dispatch, match } = this.props;
    const { shopifyToken, store, inviteToken } = this.state;
    let user = formData.toJS();
    if (inviteToken) {
      user.inviteToken = inviteToken;
    }

    if ((match.params.title === 'free') || (match.params.title === 'appsumo')) {
      user.planId = match.params.title;

      user.shopifyToken = shopifyToken;
      user.shopifyStore = store;
      await dispatch(signup(user));
      await dispatch(load());
      return;
    }

    const data = await dispatch(check_signup(user));
    if (data) {
      await dispatch(push('/plan'));
      localStorage.setItem('userObject', JSON.stringify(user));
    }
  }

  render() {
    const { loading, signupError, handleSubmit, match, signupFormOpts } = this.props;
    const { shopifyToken, store, inviteEmail, inviteToken } = this.state;

    localStorage.setItem('title', match.params.title ? match.params.title : '');

    const isFreeSignUp = match.params.title === 'free';
    const isAppsumo = match.params.title === 'appsumo';
    const isInvitedUser = !!inviteToken;

    return (
      <div className="height signup-bg">
        <Modal className="registrationform" size="tiny" open="true">
          {
            signupError && (
              <Message error content={signupError} />
            )
          }
          <Modal.Header className= "signupHeader primaryColor">
            <a href="/"><Image src={Images.logo} size='medium' centered/></a>
            { isAppsumo && <a href="/"><Image src={Images.appsumo} size='medium' centered/></a> }
            {createAccountLabel(isFreeSignUp, isInvitedUser)}
          </Modal.Header>
          <Modal.Content>
            <Form loading={loading} onSubmit={ handleSubmit(this.onSubmit) }>
              <Input
                className="signupFirstName"
                name="firstName"
                data-testid="signupFirstName"
                icon="user"
                iconPosition="left"
                placeholder="First Name"
                type="text"
                size="large"
                validate={[required, maxLength50]}
              />
              <Input
                className="signupLastName"
                name="lastName"
                data-testid="signupLastName"
                icon="user"
                iconPosition="left"
                placeholder="Last Name"
                type="text"
                size="large"
                validate={[required, maxLength50]}
              />
              <Input
                className="signupJobTitle"
                name="jobTitle"
                data-testid="signupJobTitle"
                icon="user"
                iconPosition="left"
                placeholder="Job Title"
                type="text"
                size="large"
                validate={[required, maxLength50]}
              />
              <Input
                className="signupCompanyName"
                name="companyName"
                data-testid="signupCompanyName"
                icon="user"
                iconPosition="left"
                placeholder="Company Name"
                type="text"
                size="large"
                validate={[required, maxLength50]}
              />
              { inviteEmail
                ? <Input
                  className="signupInvitedUsername"
                  name="username"
                  data-testid="signupInvitedUsername"
                  icon="user"
                  iconPosition="left"
                  type="text"
                  size="large"
                  disabled={true}
                />
                : <Input
                  className="signupCompanyEmail"
                  name="username"
                  data-testid="signupCompanyEmail"
                  icon="user"
                  iconPosition="left"
                  placeholder="Company Email"
                  type="text"
                  size="large"
                  validate={[required, email, maxLength50]}
                  autoCorrect="off"
                  autoCapitalize="none"
                />
              }
              <Input
                className="signupPassword"
                name="password"
                data-testid="signupPassword"
                icon="key"
                iconPosition="left"
                placeholder="Password"
                type="password"
                autoComplete="new-password"
                size="large"
                validate={[required, minPasswordLength, maxLength50]}
              />
              {
                isFreeSignUp &&
                <Input
                  className="signupPhoneNumber"
                  name="phoneNumber"
                  data-testid="signupPhoneNumber"
                  icon="phone"
                  iconPosition="left"
                  placeholder="Phone"
                  type="text"
                  size="large"
                  validate={[required, minPhoneLength, maxPhoneLength]}
                />
              }
              {
                isAppsumo &&
                <Input
                  name="appSumoCode"
                  data-testid="signupAppSumoCode"
                  placeholder="AppSumo code"
                  type="text"
                  size="large"
                  validate={[required]}
                />
              }
              <hr />
              <Dropdown
                name="budgetId"
                data-testid="signupBudgetOption"
                icon="caret down"
                label="Approximate Marketing Budget"
                placeholder="Approximate Marketing Budget"
                className="signupBudgetOption budgetDropdown"
                selection
                options={signupFormOpts.availableBudgets}
                validate={[required]}
              />
              <Dropdown
                  name="referralSourceId"
                  data-testid="signupReferralSourceOption"
                  icon="caret down"
                  label="How did you hear about VideoPeel?"
                  placeholder="How did you hear about VideoPeel?"
                  className="signupReferralSourceOption budgetDropdown"
                  selection
                  options={signupFormOpts.referralSource}
                  validate={[required]}
              />
              <Dropdown
                  name="companyIndustryId"
                  data-testid="signupCompanyIndustryOption"
                  icon="caret down"
                  label="What industry are you in?"
                  placeholder="What industry are you in?"
                  className="signupCompanyIndustryOption budgetDropdown"
                  selection
                  options={signupFormOpts.industry}
                  validate={[required]}
              />
              <div className="conditions">
                <Input
                  className="signupTermAndPolicy"
                  name="isTermAndPolicyChecked"
                  data-testid="signupTermAndPolicy"
                  type="checkbox"
                  validate={[requiredToBeTrue]}
                />
                <label>I agree to the
                  <a href="https://videopeel.com/termsofuse/" target="_blank" className="hoverStyle"> Terms Of Use </a>
                  and
                  <a href="https://videopeel.com/privacypolicy/" target="_blank" className="hoverStyle"> Privacy Policy</a>
                </label>
              </div>
              <Button
                data-testid="signupSubmitButton"
                className="ui small fluid button front"
                type="submit"
                primary loading={loading}
              >
                NEXT
              </Button>
              {
                shopifyToken && isFreeSignUp &&
                <p className="signupHeader">Already have an account?
                  <a className="prevsignin" href={`/shopify/?shopifyToken=${shopifyToken}&store=${store}`}>
                    <span> Sign In</span>
                  </a>
                </p>
              }
            </Form>
          </Modal.Content>
          <div className="signupFooter">
            <p className= "signupHeader pb10">&copy;{new Date().getFullYear()} VideoPeel</p>
          </div>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.get('auth').get('user'),
    signupFormOpts: state.get('auth').get('signupFormOpts'),
    signupInfo: state.get('auth').get('signupInfo'),
    signupError: state.get('auth').get('signupError'),
    loading: state.get('auth').get('loading')
  }
}

export default connect(mapStateToProps)(reduxForm({
  form: 'signup'
})(Signup))



// WEBPACK FOOTER //
// ./src/containers/Signup/Signup.js